import styled from 'styled-components';

export const CustomRowTable = styled.div`
  display: grid;
  grid-template-columns: 80px 30% 29% 30% 120px;
  align-items: center;
  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 20px;
  }
  &:not(:first-child) {
    padding-top: 20px;
  }
`;

export const TableGrid2 = styled.div`
  grid-column: 3 / 4;
  padding-right: 20px;
`;

export const TableGrid3 = styled.div`
  grid-column: 4/ 5;
`;

export const HiddenText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`